import React from "react";
import { KeyRound } from "lucide-react";

/** Monthly Record - Account Access section (spec item 11, lowest priority - lightweight
 * only). Uses fields already present on the employee record; no dedicated history/fetch
 * for this section in Phase 1 by design (deferred first if scope needs to shrink). */
export const AccountAccessSection = ({ employee }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid="monthly-account-access-section">
    <div className="flex items-center gap-2 mb-3"><KeyRound size={16} className="text-slate-500" /><p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Account Access</p></div>
    <p className="text-sm text-slate-600" data-testid="monthly-account-access-status">
      {employee?.user_id ? "Staff portal account is active for this employee." : "No staff portal account has been granted yet."}
    </p>
  </div>
);
